import { types } from 'mobx-state-tree';


const INTENDED_USE = {
    OWNER_OCCUPIED: 'owner-occupied',
    OWNER_OCCUPIED_RENTAL: 'owner-occupied-and-rental',
    RENTAL: 'rental',
    SECOND_HOME: 'second-home',
};

const IntendedUseEnum = types.enumeration('IntendedUse', Object.values(INTENDED_USE));

export {
    IntendedUseEnum,
};
export default INTENDED_USE;
